"use client";

import { ClerkLoaded, ClerkLoading, RedirectToSignIn, Show } from "@clerk/nextjs";
import type { ReactNode } from "react";

import { LoadingPage } from "@/components/loading-page";

/**
 * Client-side signed-in UX for routes already protected with `auth.protect()`.
 *
 * Server layouts remain the security boundary. This gate preserves a clean
 * experience when the session ends mid-navigation (sign-out, expiry) without
 * flashing protected client UI.
 */
export function AuthSignedInGate({ children }: { children: ReactNode }) {
  return (
    <>
      <ClerkLoading>
        <AuthGateLoading />
      </ClerkLoading>
      <ClerkLoaded>
        <Show when="signed-in">{children}</Show>
        <Show when="signed-out">
          <AuthGateLoading />
          <RedirectToSignIn />
        </Show>
      </ClerkLoaded>
    </>
  );
}

function AuthGateLoading() {
  return (
    <div className="bg-background flex min-h-dvh w-full items-center justify-center">
      <LoadingPage />
    </div>
  );
}
